import { useMemo, useState } from 'react';

export const usePagination = <T>(data: T[]) => {
  const [page, setPage] = useState(0);
  const [volume, setVolume] = useState(10);

  const totalPages = useMemo(() => Math.floor(data.length / volume), [volume, data.length]);
  const slicedData = useMemo(() => data.slice(page * volume, page * volume + volume), [volume, page, data]);

  return { data: slicedData, page, totalPages, setPage, setVolume, volume };
};
